export enum AddressComponentMap {
  STATE = 'administrative_area_level_1',
  CITY = 'locality',
  COUNTRY = 'country',
  ZIPCODE = 'postal_code',
}

export enum NameTypes {
  LONG = 'long_name',
  SHORT = 'short_name',
}
